/* TOMOSHIN 商品ページ：バリエーション選択・カート追加・画像ギャラリー */
(function () {
  'use strict';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initProduct(root) {
    if (!root || root.dataset.tmReady) return;
    root.dataset.tmReady = '1';

    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-tm-variants]').textContent); } catch (e) { variants = []; }

    var form = root.querySelector('[data-tm-form]');
    var idInput = root.querySelector('[data-tm-variant-id]');
    var qtyInput = root.querySelector('[data-tm-qty-input]');
    var addBtn = root.querySelector('[data-tm-add]');
    var addLabel = root.querySelector('[data-tm-add-label]');
    var buyNow = root.querySelector('[data-tm-buy-now]');
    var addProxy = root.querySelector('[data-tm-add-proxy]');
    var priceEl = root.querySelector('[data-tm-price]');
    var priceMobile = root.querySelector('[data-tm-price-mobile]');
    var noteEl = root.querySelector('[data-tm-price-note]');
    var noteMobile = root.querySelector('[data-tm-price-note-mobile]');
    var mainImg = root.querySelector('.tm-gallery__main img');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tm-thumb]'));
    var optionEls = Array.prototype.slice.call(root.querySelectorAll('[data-tm-option]'));
    var preNote = root.querySelector('[data-tm-preorder-note]');
    var preLabel = (addLabel && addLabel.dataset.preorderLabel) || '予約する';

    /* ---- いま選ばれているオプション値を読む ---- */
    function readOption(optEl) {
      var pressed = optEl.querySelector('.tm-swatch-btn[aria-pressed="true"]');
      if (pressed) return { value: pressed.dataset.tmValue, group: null, sub: null };
      var radio = optEl.querySelector('input[type="radio"]:checked');
      if (!radio) return { value: null };
      var group = radio.dataset.tmGroup;
      if (radio.dataset.tmSubs) {
        var picker = optEl.querySelector('[data-tm-subpicker="' + cssEscape(group) + '"]');
        var subBtn = picker && picker.querySelector('[data-tm-sub][aria-pressed="true"]');
        var sub = subBtn ? subBtn.dataset.tmSub : radio.dataset.tmSubs.split('|')[0];
        return { value: group + '（' + sub + '）', group: group, sub: sub };
      }
      return { value: radio.dataset.tmSingle || group, group: group, sub: null };
    }

    function cssEscape(str) {
      return window.CSS && CSS.escape ? CSS.escape(str) : String(str).replace(/"/g, '\\"');
    }

    function selectedValues() {
      return optionEls.map(function (el) { return readOption(el); });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }

    /* ---- 画像 ---- */
    function showImage(src, alt, mediaId) {
      if (!mainImg || !src) return;
      mainImg.style.opacity = '0';
      setTimeout(function () {
        mainImg.removeAttribute('srcset');
        mainImg.src = src;
        mainImg.alt = alt || '';
        mainImg.style.opacity = '1';
      }, 130);
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.mediaId) === String(mediaId)); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.dataset.src, t.dataset.alt, t.dataset.mediaId); });
    });

    /* ---- 表示の更新 ---- */
    function update(changedColor) {
      var sel = selectedValues();
      var values = sel.map(function (s) { return s.value; });
      var variant = findVariant(values);

      // セットカードごとの価格（今のカラーのまま、そのセットを選んだ場合の価格）
      optionEls.forEach(function (optEl, idx) {
        optEl.querySelectorAll('input[type="radio"][data-tm-group]').forEach(function (radio) {
          var g = radio.dataset.tmGroup;
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) {
              if (i === idx) return o.split('（')[0].trim() === g;
              return o === values[i];
            });
          });
          var priceSpan = optEl.querySelector('[data-tm-group-price="' + cssEscape(g) + '"]');
          if (priceSpan && match) priceSpan.textContent = match.price + '（税込）';
        });
        // 香り選択の表示／非表示
        var current = sel[idx];
        optEl.querySelectorAll('[data-tm-subpicker]').forEach(function (p) {
          p.hidden = !(current && current.group === p.dataset.tmSubpicker);
        });
      });

      // 価格横の注記（例：オイル付きセット・CALM）
      var note = '';
      sel.forEach(function (s) {
        if (s.group) note = s.sub ? s.group + '・' + s.sub : s.group;
      });
      if (noteEl) noteEl.textContent = note;
      if (noteMobile) noteMobile.textContent = note;

      var available = !!(variant && variant.available);
      if (variant) {
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        if (priceMobile) priceMobile.textContent = variant.price + '（税込）';
        if (changedColor && variant.media) {
          var thumb = thumbs.find(function (t) { return String(t.dataset.mediaId) === String(variant.media); });
          if (thumb) showImage(thumb.dataset.src, thumb.dataset.alt, variant.media);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      var pre = !!(variant && available && variant.preorder);
      var cartText = pre ? preLabel : 'カートに追加する';
      if (addLabel) addLabel.textContent = variant ? (available ? cartText : '売り切れ') : 'この組み合わせは選べません';
      if (addProxy) addProxy.textContent = cartText;
      if (preNote) preNote.hidden = !pre;
      [addBtn, buyNow, addProxy].forEach(function (b) { if (b) b.disabled = !available; });
    }

    // 選択肢が1種類だけの商品（例：オイル＝香りだけ）は、香りを選んだときも画像を切り替える
    var singleOption = optionEls.length === 1;

    /* ---- クリック・変更イベント ---- */
    root.querySelectorAll('.tm-swatch-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.tm-swatches').querySelectorAll('.tm-swatch-btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        update(true);
      });
    });
    root.querySelectorAll('input[type="radio"][data-tm-group]').forEach(function (r) {
      r.addEventListener('change', function () { update(singleOption); });
    });
    root.querySelectorAll('[data-tm-sub]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('[data-tm-subpicker]').querySelectorAll('[data-tm-sub]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        update(singleOption);
      });
    });

    /* ---- 数量 ---- */
    function clampQty() {
      var n = parseInt(qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      qtyInput.value = n;
    }
    root.querySelectorAll('[data-tm-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.tmQty, 10);
        clampQty();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    /* ---- カートに追加 ---- */
    function addToCart(goCheckout) {
      clampQty();
      var buttons = [addBtn, buyNow, addProxy].filter(Boolean);
      buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
      return fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Number(qtyInput.value) }] })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.data && (r.data.description || r.data.message) || 'カートに追加できませんでした');
          if (goCheckout) {
            window.location.href = rootUrl() + 'checkout';
            return;
          }
          return fetch(rootUrl() + 'cart.js').then(function (res) { return res.json(); }).then(function (cart) {
            if (window.tmUpdateCartCount) window.tmUpdateCartCount(cart.item_count);
            if (window.tmToast) window.tmToast('カートに追加しました <a href="' + rootUrl() + 'cart">カートを見る</a>');
          });
        })
        .catch(function (err) {
          if (window.tmToast) window.tmToast(err.message);
        })
        .finally(function () {
          buttons.forEach(function (b) { b.classList.remove('is-loading'); });
          update(false);
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(false);
    });
    if (buyNow) buyNow.addEventListener('click', function () { addToCart(true); });
    if (addProxy) addProxy.addEventListener('click', function () { addToCart(false); });
    /* ページ下のバナーのボタン：ページ上部のカラー・セット選択までスクロールで戻る */
    document.querySelectorAll('[data-tm-scroll-to-buy]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        // PC（横並び）は商品ブロックの先頭、スマホ（縦並び）は商品名のところへ
        var target = window.matchMedia('(max-width: 1050px)').matches
          ? root.querySelector('.tm-pdp__info')
          : root;
        if (!target) return;
        var header = document.querySelector('.tm-header');
        var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        // 選ぶ場所がわかるように、最初の選択肢へフォーカス（キーボード操作の人向け）
        var first = root.querySelector('.tm-swatch-btn[aria-pressed="true"], .tm-swatch-btn, input[type="radio"]');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduce ? 0 : 600);
      });
    });

    /* ---- 画像の拡大 ---- */
    var modal = root.querySelector('[data-tm-modal]');
    var modalImg = root.querySelector('[data-tm-modal-image]');
    var zoom = root.querySelector('[data-tm-zoom]');
    function closeModal() { if (modal) modal.hidden = true; document.body.style.overflow = ''; }
    if (zoom && modal) {
      zoom.addEventListener('click', function () {
        modalImg.src = mainImg.currentSrc || mainImg.src;
        modalImg.alt = mainImg.alt;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        root.querySelector('[data-tm-modal-close]').focus();
      });
      root.querySelector('[data-tm-modal-close]').addEventListener('click', closeModal);
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    }

    update(false);
  }

  function initAll() {
    document.querySelectorAll('[data-tm-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
